import { GroupSecurity } from '@quromedical/fhir-common';
import type { LocationSearchParams } from '@quromedical/models';
import { CrudForm } from 'components/form';
import { WithGroup } from 'core/auth';
import {
  columns,
  getLocationDataFromResponse,
  initialSearch,
  LocationCreateCard,
  type LocationTable,
  searchFields,
} from 'core/location';
import { PaginatedTable } from 'core/table';
import { Section, ToggleCard } from 'design-system';
import { router } from 'expo-router';
import { useResponsive } from 'hooks/useResponsive';
import { organizationFetcher } from 'integration';
import { LocationApi } from 'integration/aggregate';
import type { GroupStackScreenProps } from 'navigation';
import type React from 'react';
import { useCallback, useState } from 'react';
import { ScrollView } from 'react-native-gesture-handler';
import { strings } from 'strings';

const api = new LocationApi();

export const LocationListScreen: React.FC<
  GroupStackScreenProps<'List'>
> = () => {
  const [search, setSearch] = useState<LocationSearchParams>(initialSearch);

  const isStriped = useResponsive({ md: true }, false);

  const fetcher = () => api.getAllLocations(search);

  const orgFetcher = organizationFetcher();

  const onRowPress = useCallback((row: LocationTable) => {
    const id = row.id;
    if (!id) return;

    router.push(`/admin/location/${id}`);
  }, []);

  return (
    <ScrollView>
      <WithGroup groups={[GroupSecurity.DeviceCreate]}>
        <Section unsetZIndex>
          <ToggleCard
            icon="location-pin"
            title={strings.LocationToggleCardTitle}
            textExpand={strings.LocationToggleCardExpandButtonText}
            textCollapse={strings.LocationToggleCardCollapseButtonText}
            contentWrapperProps={{ paddingHorizontal: 0, paddingVertical: 0 }}
          >
            <LocationCreateCard organizationFetcher={orgFetcher} />
          </ToggleCard>
        </Section>
      </WithGroup>
      <Section unsetZIndex>
        <CrudForm
          fields={searchFields}
          initialValues={initialSearch}
          showSubmitButton={false}
          onChange={setSearch}
        />
      </Section>
      <Section>
        <PaginatedTable
          cacheKey={`Location${JSON.stringify(search)}`}
          fetcher={fetcher}
          columns={columns}
          showHeader={true}
          isStriped={isStriped}
          getDataFromResponse={getLocationDataFromResponse}
          onRowPress={onRowPress}
        />
      </Section>
    </ScrollView>
  );
};
